import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { ROUTE_NAMES } from "@bakbak/common";
import { SendForgotPasswordEmailController } from "@bakbak/controller";

import { SendForgotPasswordEmailView } from "./SendForgotPasswordEmailView";

// container -> view
// container -> connector -> view
// controller -> container -> view

export class SendForgotPasswordEmailConnector extends React.PureComponent<
  RouteComponentProps<{}>
> {
  onComplete = () => {
    this.props.history.push(
      `${ROUTE_NAMES.MESSAGE}${ROUTE_NAMES.RESET_PASSWORD}`,
      {
        message: "check your email to reset your password"
      }
    );
  };
  render() {
    return (
      <SendForgotPasswordEmailController>
        {({ submit }: any) => (
          <SendForgotPasswordEmailView
            onComplete={this.onComplete}
            submit={submit}
          />
        )}
      </SendForgotPasswordEmailController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/sendForgotPasswordEmail/SendForgotPasswordEmailConnector.tsx